var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlexishr = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1208_317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H64V63.2668H0V0ZM43.2236 33.2631L47.1981 48.4436V48.5329H54.6956L50.2694 31.5218C49.6822 29.2447 49.0499 26.8785 48.0111 24.6013C46.8818 22.1009 45.3463 19.7792 42.9073 17.9041C42.0945 17.2789 41.2814 16.7433 40.4684 16.2968C39.6554 15.8503 38.752 15.4483 37.8036 15.1358C36.9002 14.7787 35.9067 14.5554 34.9129 14.3769C33.9193 14.1982 32.9257 14.1089 31.9321 14.1089C27.0091 14.1089 22.5375 16.1181 19.3309 19.2882C16.079 22.4582 14.0916 26.8785 14.0916 31.7451C14.0916 36.6118 16.1241 41.0319 19.3309 44.2019C22.5375 47.4166 27.0091 49.3812 31.9321 49.3812C34.5969 49.3812 37.1262 48.7561 39.4296 47.7291C40.0168 47.4612 40.6039 47.1488 41.1911 46.7915L39.2037 39.2013C38.3908 39.9604 37.4423 40.6301 36.3584 41.1211C35.0032 41.7016 33.513 42.0587 31.9321 42.0587C29.0414 42.0587 26.4217 40.8979 24.5248 39.0228C22.628 37.1476 21.4537 34.5579 21.4537 31.7003C21.4537 28.8429 22.628 26.2534 24.5248 24.3781C26.4217 22.5029 29.0414 21.3419 31.9321 21.3419C32.6096 21.3419 33.1967 21.3867 33.7387 21.4761C34.3258 21.5654 34.9129 21.7437 35.4549 21.9224C35.9517 22.1009 36.4938 22.3244 36.9906 22.5922C37.5326 22.9047 37.9843 23.2172 38.436 23.5298C41.2224 25.6911 42.2185 29.461 43.0851 32.7405C43.1315 32.9162 43.1777 33.0905 43.2236 33.2631Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1208_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlexishr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alexishr.029c1562a75e4781cba9d45771861b16.svg";